import InputDropdown from './input-dropdown';

export default InputDropdown;